export default __webpack_public_path__ + "static/media/video-key-green.5f922920.svg";